module.exports = __webpack_public_path__ + "static/img/banne1.7583120a.png";